import React from 'react';
import PropTypes from 'prop-types';
import {Row,Col} from "reactstrap";
import background from '../../assets/custom/meme3.png';
class AlertDismissable extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      show: this.props.show,
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.state.show) {
      this.setState({ show: nextProps.show });
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    if (this.state.show) {
      return (
        <Row>
          <Col md="6">
            <h2 style={{color:'crimson',fontWeight:"bold"}}><small>Hold Up! You got an error!</small></h2>
            <p style={{ whiteSpace: 'pre-wrap' ,color:'crimson',fontSize:'1rem' ,fontWeight:'bold'}}>{this.props.errorType} error</p>
            <p style={{ whiteSpace: 'pre-wrap' ,color:'crimson',fontSize:'1rem' ,fontWeight:'bold'}}>{this.props.message}</p>
          </Col>
          <Col md="6">
            <img src={background} alt="meme"/>
          </Col>
        </Row>
      );
    }

    return '';
  }
}

AlertDismissable.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  errorType: PropTypes.string.isRequired
};

export default AlertDismissable;
